import { Record, Union } from "../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, option_type, bool_type, class_type, union_type, string_type } from "../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Sepa_SaveMandatResult_$reflection, Sepa_OpenMandat_$reflection } from "../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.19.0/Result.js";
import { GlobalMsg_$reflection } from "../../../Bfs.Web.Portale/Types.fs.js";
import { FormField_$reflection } from "../../../Bfs.Web.Portale/Validation.fs.js";

export class Page extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["SepaMandat"];
    }
}

export function Page_$reflection() {
    return union_type("Bfs.Web.Kundenportal.WebParts.Sepa.Types.Page", [], Page, () => [[["Item", string_type]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadData", "LoadDataCompleted", "GlobalMsg", "RechnungsempfaengerIstKontoinhaberChanged", "KontoinhaberChanged", "StrasseChanged", "HausnummerChanged", "PlzChanged", "OrtChanged", "MitVollmachtChanged", "BevollmaechtgterChanged", "IbanChanged", "AllowForOldPaymentsChanged", "ConfirmedChanged", "ValidateCanSubmit", "Submit", "SubmitCompleted"];
    }
}

export function Msg_$reflection() {
    return union_type("Bfs.Web.Kundenportal.WebParts.Sepa.Types.Msg", [], Msg, () => [[], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Sepa_OpenMandat_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Sepa_OpenMandat_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Sepa_SaveMandatResult_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Sepa_SaveMandatResult_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]]]);
}

export class Slug extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Invalid", "Valid"];
    }
}

export function Slug_$reflection() {
    return union_type("Bfs.Web.Kundenportal.WebParts.Sepa.Types.Slug", [], Slug, () => [[], [["Item", string_type]]]);
}

export class Model extends Record {
    constructor(Slug, OpenMandat, RechnungsempfaengerIstKontoinhaber, Kontoinhaber, Strasse, Hausnummer, Plz, Ort, MitVollmacht, Bevollmaechtigter, Iban, AllowForOldPayments, Confirmed, CanSubmit, Submitting) {
        super();
        this.Slug = Slug;
        this.OpenMandat = OpenMandat;
        this.RechnungsempfaengerIstKontoinhaber = RechnungsempfaengerIstKontoinhaber;
        this.Kontoinhaber = Kontoinhaber;
        this.Strasse = Strasse;
        this.Hausnummer = Hausnummer;
        this.Plz = Plz;
        this.Ort = Ort;
        this.MitVollmacht = MitVollmacht;
        this.Bevollmaechtigter = Bevollmaechtigter;
        this.Iban = Iban;
        this.AllowForOldPayments = AllowForOldPayments;
        this.Confirmed = Confirmed;
        this.CanSubmit = CanSubmit;
        this.Submitting = Submitting;
    }
}

export function Model_$reflection() {
    return record_type("Bfs.Web.Kundenportal.WebParts.Sepa.Types.Model", [], Model, () => [["Slug", Slug_$reflection()], ["OpenMandat", option_type(Sepa_OpenMandat_$reflection())], ["RechnungsempfaengerIstKontoinhaber", bool_type], ["Kontoinhaber", FormField_$reflection()], ["Strasse", FormField_$reflection()], ["Hausnummer", FormField_$reflection()], ["Plz", FormField_$reflection()], ["Ort", FormField_$reflection()], ["MitVollmacht", bool_type], ["Bevollmaechtigter", FormField_$reflection()], ["Iban", FormField_$reflection()], ["AllowForOldPayments", bool_type], ["Confirmed", bool_type], ["CanSubmit", bool_type], ["Submitting", bool_type]]);
}

export function Model__get_Headline(model) {
    return "SEPA-Lastschriftmandat erteilen";
}

//# sourceMappingURL=Types.fs.js.map
